var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Inline, SylController, SylPlugin } from '@syllepsis/adapter';
import { checkMarkDisable } from '../../utils';
var NAME = 'sub';
var Sub = /** @class */ (function (_super) {
    __extends(Sub, _super);
    function Sub() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.tagName = function () { return 'sub'; };
        _this.excludes = 'sup';
        _this.parseDOM = [{ tag: 'sub', priority: 25 }];
        return _this;
    }
    return Sub;
}(Inline));
var SubController = /** @class */ (function (_super) {
    __extends(SubController, _super);
    function SubController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.toolbar = {
            className: 'sub',
            tooltip: 'sub'
        };
        _this.disable = function (editor) { return checkMarkDisable(editor.view, NAME); };
        return _this;
    }
    return SubController;
}(SylController));
var SubPlugin = /** @class */ (function (_super) {
    __extends(SubPlugin, _super);
    function SubPlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.Controller = SubController;
        _this.Schema = Sub;
        return _this;
    }
    return SubPlugin;
}(SylPlugin));
export { Sub, SubController, SubPlugin };
//# sourceMappingURL=index.js.map